import {Component, EventEmitter, Input, Output} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-bank-slip-step-digitable',
  templateUrl: './bank-slip-step-digitable.component.html',
  standalone: false,
})
export class BankSlipStepDigitableComponent {
  @Input() form!: FormGroup;
  @Input() submitted = false;

  @Output() readonly scanRequested = new EventEmitter<void>();

  constructor(private readonly translate: TranslateService) {}

  get digitableCustomMessages(): Record<string, string> {
    const p = 'features.withdrawals.modalBankSlip';
    return {
      required: this.translate.instant(`${p}.digitableRequired`),
      invalidDigitableLine: this.translate.instant(`${p}.digitableInvalid`),
    };
  }
}
